<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">ADMINISTRAR OPCIONALES</h1>
        </section>

        <section id="table">
            <mat-card class="mat-elevation-z0">
                <div>
                    <button mat-flat-button class="add-btn" (click)="addOptional()">Agregar nueva</button>
                </div>

                <table mat-table [dataSource]="allOptionals" class="mat-elevation-z0">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="table-header">NOMBRE</th>
                        <td mat-cell *matCellDef="let optional"> {{optional.dsName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="option">
                        <th mat-header-cell *matHeaderCellDef class="table-header">OPCIONES</th>
                        <td mat-cell *matCellDef="let optional">
                            <button mat-mini-fab class="edit-btn" (click)="editOptional(optional.cdOptional)"
                            matTooltip="Editar opcional"><mat-icon>create</mat-icon>
                            </button>
                            <button mat-mini-fab class="delete-btn" (click)="deleteOptional(optional.cdOptional)"
                            matTooltip="Eliminar opcional"><mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </mat-card>
        </section>
    </div>
</div>